<template>
    <article class="page page-directors">
        <div v-if="$root.mobileDetected" class="page-directors-list">
            <router-link 
                v-for="director in directors"
                :key="director.name"
                class="page-directors-list-item"
                :to="{name: $route.name === 'directors' ? 'directors-single' : 'private-pages-details', params: {slug: director.slug}}"
            >
                {{ director.name }}
            </router-link>
        </div>
        <div 
            class="page-directors__mediaBg"
            v-if="!$root.mobileDetected"
        >
            <img ref="mediaBgImage" src="" alt="">
            <video ref="mediaBgVideo" muted autoplay loop src=""></video>
        </div>
        <div v-if="!$root.mobileDetected" ref="canvas-container" class="scene-directors-list"></div>
    </article>
</template>

<script>

// Data
import {directors as __directors} from '../../__data'

// Components

// Scene
import SceneDirectors from '../../helpers/threejs/scenes/SceneDirectors'

// Utils
import MyEmitter from '../../helpers/MyEmitter'
import params from '../../utils/params'
import Utils from '../../utils/utils'

const randomVideos = [
    "https://ubiquity.tv/backend/media/pages/slider/audrey-mascina-lancome-idole-l-intense/870123934-1600247520/slider_idole-l-intense.mp4",
    "https://ubiquity.tv/backend/media/pages/slider/repetto/3406780540-1599891895/1.-repetto-manifeste-audrey-mascina.mp4",
    "https://ubiquity.tv/backend/media/pages/slider/lancome/2702929876-1599891895/2.-lancome-idoles-audrey-mascina.mp4",
    "https://ubiquity.tv/backend/media/pages/slider/lancome-voices/1088241513-1599891895/3.-lancome-voices-chris-roman-_h.264.mp4",
]


export default {
    data: function(){
        return {
            directors: [],
            isPrivatePage: false,
            detailsRouteName: "director-single"
        }
    },
    name: "PageDirectors",
    beforeDestroy: function(){

        // on mobile there is no scene
        this.sceneDirectors && this.sceneDirectors.destroy()
    },
    beforeRouteLeave(to, from, next){
        if(!this.$root.mobileDetected){
            // only on desktop
            this.sceneDirectors._animateExit(() => {
                next()
            })
        } else {
            next()
        }
    },
    mounted: function(){

        let routeName = this.$route.name
        
        Utils.fetch("/directors").then(res => {

            this.directors = res.filter(d => d.invisible === "false").map((director, directorIndex) => {

                // let isImage = Math.random() > .5

                return {
                    id: directorIndex,
                    name: director.title || "",
                    slug: director.slug,
                    // backgroundImage: isImage ? "https://picsum.photos/id/" + Math.floor(Math.random() * 20) + "/1000/1000" : null,
                    // backgroundVideo: !isImage ? randomVideos[directorIndex % (randomVideos.length - 1)] : null

                    backgroundImage: director.background_image,
                    backgroundVideo: director.background_video
                    
                }
            })

            let videoElements = this.directors.filter(d => d.backgroundVideo).map((d, index) => ({
                src: d.backgroundVideo
            })) || []

            if(videoElements.length){

                Utils.waitForRessourcesVideos(videoElements, () => {

                    // waitig for ressources
                    MyEmitter.emit(params.Events.appHasLoadedRessources)

                })
            } else {

                // waitig for ressources
                MyEmitter.emit(params.Events.appHasLoadedRessources)

            }

            // 3d only for desktop
            if(this.$root.mobileDetected) return

            this.sceneDirectors = new SceneDirectors(this.$refs["canvas-container"], {}, {
                directors: this.directors,
                updateRoute: this.pushDirectorSingle,
                mediaBgImage: this.$refs["mediaBgImage"],
                mediaBgVideo: this.$refs["mediaBgVideo"],
            })
            this.sceneDirectors.init()
            this.sceneDirectors.start()

        })
    },

    methods: {
        pushDirectorSingle: function(slug){

            if(slug === null || typeof slug === "undefined") {
                console.error("Provided url params is null or undefined")
                return;
            }

            if(slug === "ubiquity-tv-contact"){
                this.$router.push({name: "contact"})
            } else {
                let directorsSingleDetailsRoute = this.isPrivatePage ? "private-pages-details" : "directors-single"
                this.$router.push({name: directorsSingleDetailsRoute, params: {slug: slug}})
            }


        },
    }
}
</script>

<style lang="scss">
    .page-directors{
        display: flex;

        &__mediaBg{
            @include absolute-fullscreen();

            img, video{
                @include absolute-fullscreen();
                object-fit: cover;
                object-position: center;
                opacity: 0;
                visibility: hidden;
                // transition: ease 500ms;
                // transition-property: visibility, opacity;
                filter: brightness(.5);

                &.active{
                    opacity: 1;
                    visibility: visible
                }
            }

            img{
                z-index: 1
            }
        }

        .scene-directors-list{
            @include absolute-fullscreen();
            z-index: 1;

        }

        &-list{
            width: 100%;
            padding-top: 25vh;
            overflow-y: auto;

            &-item{
                display: block;
                font-size: ptToPx(32);
                text-transform: uppercase;
                font-weight: 700;
                font-family: $font-title;
                text-align: center;
                line-height: ptToPx(50);
                width: 100%;

                @include very-small{
                    font-size: ptToPx(20);
                    line-height: ptToPx(35);
                }
            }
        }
    }
</style>